<template>
  <div id="add-order">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Tạo mới Đơn hàng', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-5">
      <block :nobody="true" ref="bqouta" class="soft-control">
        <!-- <b-row align-v="center" class="text-center">
          <b-col><h3 class="mt-3">Báo giá mới</h3></b-col>
        </b-row>
        <hr /> -->
        <b-row class="mx-0" align-h="center">
          <b-col md="10 px-0 border-right border-info">
            <b-card class="m-3">
              <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
                <form role="form" @submit.prevent="handleSubmit(doSave)">
                  <b-row>
                    <b-col>
                      <base-input
                        class="mb-2"
                        :disabled="order.id != ''"
                        v-model="order.code"
                        label="Mã đơn hàng"
                        placeholder="Không nhập hệ thống sẽ tự phát sinh"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <div class="mb-2">
                        <label for="datepicker-lg">Ngày tạo</label>
                        <b-form-datepicker
                          :disabled="order.id != ''"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="order.dateReceipt"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                    <b-col>
                      <base-input class="mb-2" label="Người Tạo" readonly :value="info.name"> </base-input>
                    </b-col>
                  </b-row>
                  <fieldset class="border-info mb-3">
                    <legend>
                      Thông tin đặt hàng:
                      <b-button
                        v-if="order.id == '' && order.quota && !order.quota.id"
                        size="sm"
                        @click="addNewCustomer"
                        variant="success"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Tạo mới khách hàng
                      </b-button>
                      <span class="bg-light px-2">{{ order.customer.fax }}</span>
                    </legend>
                    <b-row>
                      <b-col md="3">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <base-select
                            :disabled="order.id != '' || (order.quota && order.quota.id)"
                            @change="orderCustomerChange"
                            v-model="order.customer"
                            label="Mã khách hàng"
                            :ajaxData="getCustomer"
                            :error="errors[0]"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.code }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.code }}</strong> <br />
                                <span>{{ item.name }}</span>
                              </div>
                            </template>
                          </base-select>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="3">
                        <base-select
                          :disabled="order.id != '' || (order.quota && order.quota.id)"
                          v-model="order.customer"
                          label="Tên khách hàng"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                      <b-col md="3">
                        <base-select
                          :disabled="order.id != '' || (order.quota && order.quota.id)"
                          v-model="order.customer"
                          label="Email khách hàng"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.email }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                      <b-col md="3">
                        <base-input :disabled="order.id != ''" label="Mã PO" placeholder="" v-model="order.poCode">
                        </base-input>
                      </b-col>
                    </b-row>
                    <hr class="m-1" />
                    <template v-if="order.customer && order.customer.id">
                      <b-button
                        v-if="order.id == '' && order.quota && !order.quota.id"
                        @click="addNewCustomerContact"
                        size="sm"
                        pill=""
                      >
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                        Thêm mới người liên hệ
                      </b-button>
                      <b-row>
                        <b-col md="3">
                          <base-select
                            :disabled="order.id != ''"
                            v-model="order.customerContact"
                            label="Tên người liên hệ"
                            :options="order.customer.customerContacts"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.name }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.name }}</strong>
                                <br />
                                <span>{{ item.email }}</span> <br />
                                Loại :
                                <b-badge variant="primary" v-if="item.type == 'ORDER'">
                                  Người đặt hàng
                                </b-badge>
                                <b-badge variant="success" v-else-if="item.type == 'PAYMENT'">
                                  Người thanh toán
                                </b-badge>
                                <b-badge variant="info" v-else>
                                  Người nhận hàng
                                </b-badge>
                              </div>
                            </template>
                          </base-select>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Email" placeholder="" readonly v-model="order.customerContact.email">
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Địa chỉ" placeholder="" readonly v-model="order.customerContact.address">
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Điện thoại" placeholder="" readonly v-model="order.customerContact.phone">
                          </base-input>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-if="order.quota && order.quota.id">
                      <div class="table-responsive base-table table-soft mt-2" style="min-height:unset">
                        <table class="table table-bordered b-table b-table-no-border-collapse">
                          <thead>
                            <tr>
                              <th>Mã báo giá</th>
                              <th>Được tạo ngày</th>
                              <th>Người tạo</th>
                              <th>Người duyệt</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">
                                <b>{{ order.quota.code }}</b>
                              </td>
                              <td class="text-center">
                                {{ $dateTimeUnix(order.quota.dateCreated) }}
                              </td>
                              <td>
                                <b>{{ order.quota.userCreate.username }}</b>
                                <br />
                                <span>{{ order.quota.userCreate.name }}</span>
                              </td>
                              <td>
                                <b>{{ order.quota.userVerify.username }}</b>
                                <br />
                                <span>{{ order.quota.userVerify.name }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </fieldset>
                  <fieldset class="border-info">
                    <legend>
                      Thông tin nhận hàng:
                      <b-button v-if="order.id == ''" size="sm" @click="copyRecevier" variant="primary">
                        <i class="fa fa-copy" aria-hidden="true"></i>
                        Copy Thông tin đặt hàng
                      </b-button>
                      <b-button
                        v-if="order.id == '' && order.quota && !order.quota.id"
                        size="sm"
                        @click="addNewCustomer('receiver')"
                        variant="success"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Tạo mới người nhận hàng
                      </b-button>
                      <span class="bg-light px-2">{{ order.receiver.fax }}</span>
                    </legend>
                    <b-row>
                      <b-col md="3">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <base-select
                            :disabled="order.id != ''"
                            @change="orderReceiverChange"
                            v-model="order.receiver"
                            label="Mã người nhận"
                            :ajaxData="getCustomer"
                            :error="errors[0]"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.code }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.code }}</strong> <br />
                                <span>{{ item.name }}</span>
                              </div>
                            </template>
                          </base-select>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="3">
                        <base-select
                          :disabled="order.id != ''"
                          v-model="order.receiver"
                          label="Tên người nhận"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.name }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                      <b-col md="3">
                        <base-select
                          :disabled="order.id != ''"
                          v-model="order.receiver"
                          label="Email người nhận"
                          :ajaxData="getCustomer"
                          ><template v-slot:selected="{ item }">
                            <div>
                              {{ item.email }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </b-col>
                      <b-col md="3">
                        <div class="mb-2">
                          <label for="datepicker-lg">Ngày giao hàng</label>
                          <b-form-datepicker
                            :disabled="order.id != ''"
                            id="datepicker-delivery"
                            :date-format-options="{
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit'
                            }"
                            v-model="order.dateDelivery"
                            locale="vi"
                          ></b-form-datepicker>
                        </div>
                      </b-col>
                    </b-row>
                    <hr class="m-0" />
                    <template v-if="order.receiver && order.receiver.id">
                      <b-button
                        v-if="order.id == '' && order.quota && !order.quota.id"
                        @click="addNewReceiverContact"
                        size="sm"
                        pill=""
                      >
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                        Thêm mới người liên hệ
                      </b-button>
                      <b-row>
                        <b-col md="3">
                          <base-select
                            :disabled="order.id != ''"
                            v-model="order.receiverContact"
                            label="Tên người liên hệ"
                            :options="order.receiver.customerContacts"
                          >
                            <template v-slot:selected="{ item }">
                              <div>
                                {{ item.name }}
                              </div>
                            </template>
                            <template v-slot:body="{ item }">
                              <div>
                                <strong>{{ item.name }}</strong>
                                <br />
                                <span>{{ item.email }}</span> <br />
                                Loại :
                                <b-badge variant="primary" v-if="item.type == 'ORDER'">
                                  Người đặt hàng
                                </b-badge>
                                <b-badge variant="success" v-else-if="item.type == 'PAYMENT'">
                                  Người thanh toán
                                </b-badge>
                                <b-badge variant="info" v-else>
                                  Người nhận hàng
                                </b-badge>
                              </div>
                            </template>
                          </base-select>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Email" placeholder="" readonly v-model="order.receiverContact.email">
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Địa chỉ" placeholder="" readonly v-model="order.receiverContact.address">
                          </base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input label="Điện thoại" placeholder="" readonly v-model="order.receiverContact.phone">
                          </base-input>
                        </b-col>
                      </b-row>
                    </template>
                  </fieldset>
                </form>
              </ValidationObserver>
              <hr />
              <div class="d-flex">
                <h5>* Sản phẩm :</h5>
                <b-button
                  v-if="order.id == '' && order.quota && !order.quota.id"
                  @click="productOrderAddRow"
                  variant="success px-1 py-0 ml-2 mb-2"
                >
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button>
              </div>
              <base-table :data="productOrders">
                <template slot="columns">
                  <th>STT</th>
                  <th class="text-center">STYLE NO</th>
                  <th class="text-left">Mã sản phâm</th>
                  <th class="text-left">Tên sản phẩm</th>
                  <!-- <th class="text-left"></th> -->
                  <th>Diễn giải</th>
                  <th>Quy cách</th>
                  <th>Chiều dài</th>
                  <th>Hệ màu</th>
                  <th>Màu sắc</th>
                  <th>Mã màu 1</th>
                  <th>Mã màu 2</th>

                  <th class="text-right">Số lượng</th>
                  <th class="text-right">Đơn giá</th>
                  <th class="text-right">Thành tiền</th>
                  <th class="text-right">Thuế</th>
                  <th class="text-right">Thành tiền sau thuế</th>
                  <th>Loại tiền</th>
                  <th>Đơn vị tính</th>
                  <th></th>
                </template>

                <template slot-scope="{ row, index }">
                  <tr v-if="!row.edit" :key="index">
                    <td class="bg-info text-light col-fix ">
                      {{ index + 1 }}
                    </td>
                    <td class="text-left">{{ row.product.code }}</td>
                    <td class="text-left">{{ row.product.name }}</td>
                    <!-- <td class="text-left">{{ row.productCustom }}</td> -->
                    <td class="text-center">
                      <span v-if="row.reason">{{ row.reason.name }}</span>
                    </td>
                    <td class="text-center">{{ row.productSpecify.name }}mm</td>
                    <td class="text-center">{{ row.length }} cm</td>
                    <td class="text-center">
                      <span v-if="row.color">{{ row.color.label }}</span>
                    </td>
                    <td class="text-center">{{ row.colorText }}</td>
                    <td class="text-center">{{ row.colorCode }}</td>
                    <td class="text-center">{{ row.colorCode2 }}</td>

                    <!-- <td>{{ row.colorCode }}</td> -->
                    <td class="text-right">{{ $formatNumber(row.quantity) }} {{ row.unit }}</td>
                    <td class="text-right">
                      {{ $formatNumber(row.price) }} {{ row.currency }} /
                      {{ row.unit }}
                    </td>
                    <td class="text-right">{{ $formatNumber(row.total, true) }} {{ row.currency }}</td>
                    <td class="col-fix text-center"></td>
                  </tr>
                  <tr v-else :key="'_' + index">
                    <td class="bg-info text-light col-fix text-center">
                      {{ index + 1 }}
                    </td>
                    <td style="min-width:140px">
                      <base-input placeholder="STYLE NO" class="mb-0" v-model="row.poCode"> </base-input>
                    </td>
                    <td class="p-1">
                      <!-- placeholder="Nhập mã hoặc tên sản phẩm" -->
                      <base-select
                        :disabled="order.quota && order.quota.id"
                        @change="productChange(row)"
                        v-model="row.product"
                        :ajaxData="getProduct"
                        :error="!row.product || !row.product.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.code }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <span v-if="row.product">{{ row.product.name }}</span>
                    </td>
                    <!-- <td style="min-width:140px">
                      <base-input placeholder="" class="mb-0" v-model="row.productCustom"> </base-input>
                    </td> -->
                    <td style="min-width:140px">
                      <base-select
                        class="w-100"
                        @change="reasonChange($event, row)"
                        v-model="row.reason"
                        :ajaxData="getReason"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.key }} - {{ item.name }}</div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.key }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <base-select
                        :disabled="order.quota && order.quota.id"
                        @change="productSpecifyChange(row)"
                        v-if="row.product && row.product.id"
                        v-model="row.productSpecify"
                        :options="row.product.productSpecifys"
                        :error="!row.productSpecify || !row.productSpecify.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }} mm
                            <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                            - {{ item.unit }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <span>{{ item.name }} mm</span>
                            <span v-if="item.color && item.color.id"> - {{ item.color.label }} - {{ item.unit }} </span>
                          </div>
                        </template>
                      </base-select>
                      <span v-else>--Vui lòng chọn sản phẩm--</span>
                    </td>

                    <td class="p-1" style="min-width:150px">
                      <div class="d-flex">
                        <base-input :mask="'number'" placeholder="Ex : 100" v-model="row.length"> </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;"
                          >cm</span
                        >
                      </div>
                    </td>
                    <td class="p-1" style="min-width: 140px;">
                      <color
                        :disabled="order.quota && order.quota.id"
                        @change="colorChange(row)"
                        :error="!row.color || !row.color.id"
                        v-model="row.color"
                      ></color>
                    </td>
                    <td style="min-width:140px">
                      <base-input placeholder="Ex: Hồng phấn" class="mb-0" v-model="row.colorText"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:140px">
                      <base-input class="mb-0" v-model="row.colorCode"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:140px">
                      <base-input class="mb-0" v-model="row.colorCode2"> </base-input>
                    </td>

                    <td class="p-1" style="min-width:120px">
                      <div class="d-flex">
                        <base-input @change="quantityChange(row)" :mask="'number'" v-model="row.quantity"> </base-input>
                        <span style="vertical-align: middle; align-self: center; margin-left: 5px; margin-top: -8px;">{{
                          row.unit
                        }}</span>
                      </div>
                    </td>
                    <td class="p-1" style="min-width:160px">
                      <base-input
                        :load="!row.loaded"
                        :disabled="!editPrice"
                        :loadMes="'Đang tải lịch sử giá...'"
                        :mask="'number'"
                        @keyup="priceChange(row)"
                        v-model="row.price"
                      >
                      </base-input>
                    </td>
                    <td class="p-1" style="min-width:160px">
                      <base-input readonly :value="$formatNumber(row.price * row.quantity)"> </base-input>
                    </td>
                    <td class="p-1" style="min-width:120px">
                      <!-- <div class="d-flex">
                        <base-input
                          :mask="'number'"
                          v-model="row.tax"
                        >
                        </base-input>
                        %
                      </div> -->
                      <base-select v-model="row.tax" :options="['10', '8', '0']">
                        <template v-slot:selected="{ item }">
                          <div v-if="item > 0">
                            <strong>{{ item }}</strong> %
                          </div>
                          <div v-else>
                            <strong>Không chịu thuế</strong>
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div v-if="item > 0">
                            <strong>{{ item }}</strong> %
                          </div>
                          <div v-else>
                            <strong>Không chịu thuế</strong>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1" style="min-width:160px">
                      <base-input
                        readonly
                        :value="$formatNumber(row.price * row.quantity + (row.price * row.quantity * row.tax) / 100)"
                      >
                      </base-input>
                    </td>
                    <td class="p-1" style="min-width:60px">
                      <base-select v-model="row.currency" :options="['USD', 'VND']"></base-select>
                    </td>
                    <td>
                      <base-input v-model="row.unit"> </base-input>
                    </td>
                    <td class="col-fix text-center">
                      <div class="d-flex">
                        <b-button
                          class="mr-2"
                          variant="outline-danger px-1 py-0"
                          @click="productOrderDeleteRow(index, row)"
                        >
                          <i class="fa fa-backspace" aria-hidden="true"></i>
                        </b-button>
                        <div v-if="row.product && row.product.id && row.productSpecify && row.productSpecify.id">
                          <template v-if="editPrice">
                            <b-button variant="outline-info px-1 py-0" @click="copyRow(row)">
                              Copy dòng này
                            </b-button>
                            <b-button
                              v-if="row.priceHistories.total > 0"
                              @click="viewHistory(row)"
                              variant="outline-success px-1 py-0"
                            >
                              <i class="fa fa-history" aria-hidden="true"></i>
                              Lịch sử giá
                            </b-button>
                            <b-badge v-else>Chưa báo giá</b-badge>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template slot="tfoot">
                  <tr>
                    <th colspan="11">Tổng cộng</th>
                    <th colspan="1" style="text-align:right">
                      {{ $formatNumber(summary.totalQuantity) }} {{ summary.unit }}
                    </th>
                    <th style="text-align:right"></th>
                    <th style="text-align:right">{{ $formatNumber(summary.totalAmout) }} {{ summary.currency }}</th>
                    <th colspan="5"></th>
                  </tr>
                </template>
              </base-table>
              <hr />
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Ghi chú</label>
                <ckeditor :editor="editor" v-model="order.note" @ready="onReady" :config="editorConfig"></ckeditor>
              </div>
            </b-card>
          </b-col>
          <b-col md="2 px-0">
            <b-card class="m-3 sticky-top">
              <b-row>
                <b-col xl="12" class="mb-2" v-if="!dontSave">
                  <b-button @click="handleSave" variant="success" block>
                    <i class="fa fa-save" aria-hidden="true"></i>
                    {{ order.id != '' ? 'Đã lưu đơn hàng' : 'Lưu đơn hàng' }}
                  </b-button>
                </b-col>
                <b-col xl="12" class="mb-2" v-if="!dontSave">
                  <b-button :disabled="!order.id" @click="doPrint" variant="primary" block>
                    <i class="fa fa-print" aria-hidden="true"></i>
                    In đơn hàng
                  </b-button>
                </b-col>
                <b-col xl="12">
                  <b-button @click="doBack" block>
                    <i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i>
                    Trở về
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </block>
      <cs-contact-modal @submit:success="updateCustomer" ref="cs-contact-modal" />
      <customer-modal @submit:success="updateCustomer" ref="customer-modal" />
      <history ref="history" @choosePrice="handelChoosePrice"></history>
      <preview @doSave="handleSaveFromPreview" ref="preview"></preview>
    </div>
  </div>
</template>
<script>
import CustomerContactModal from '../Customer/components/CustomerContactModal';
import CustomerModal from '../Customer/components/CustomerModal';
import History from '../Quotation/__History';
import Preview from './__Preview';
import { customerService, productService, orderService, quotaService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { mapState } from 'vuex';
export default {
  name: 'add-order',
  components: {
    ckeditor: CKEditor.component,
    History,
    CustomerModal,
    Preview,
    'cs-contact-modal': CustomerContactModal
  },
  computed: {
    ...mapState('user', ['info'])
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      products: [],
      productOrders: [],
      productOrderSelect: {},
      editPrice: this.$permission('order_edit-price'),
      order: {
        id: '',
        quota: {},
        code: '',
        poCode: '',
        customer: '',
        customerContact: '',
        receiver: '',
        receiverContact: '',
        dateReceipt: new Date(),
        dateDelivery: new Date(),
        note: ''
      },
      dontSave: false,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      },
      back: -1,
      summary: {
        totalQuantity: 0,
        totalAmout: 0,
        currency: 'VND',
        unit: ''
      }
    };
  },
  created() {
    this.productOrderAddRow();
  },
  mounted() {
    var self = this;
    if (this.$route.query.id_quotation) {
      this.$refs.bqouta.block();
      quotaService
        .findOne(this.$route.query.id_quotation)
        .then(res => {
          let quota = res.data;
          this.order.customer = quota.customer;

          if (quota.customer.customerContacts.length > 0) {
            for (let i = 0; i < quota.customer.customerContacts.length; i++) {
              const element = quota.customer.customerContacts[i];
              if (element.isDefault) {
                this.order.customerContact = element;
              }
            }
            if (!this.order.customerContact.id) this.order.customerContact = quota.customer.customerContacts[0];
          }
          if (!this.order.customerContact || !this.order.customerContact.id) {
            this.dontSave = true;
            this.$swal({
              title: 'Vui lòng cập nhật người liên hệ',
              text: 'Không có người liên hệ không thể tạo đơn hàng',
              confirmButtonText: 'OK',
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonText: 'Không'
            }).then(function(result) {
              if (result.value) {
                // self.$router.go(self.back);
                self.$router.push({ name: 'quotation-manage' });
              }
            });
          }
          this.order.receiver = this.order.customer;
          this.order.receiverContact = this.order.customerContact;
          for (let j = 0; j < quota.quotaDetails.length; j++) {
            let element = quota.quotaDetails[j];
            element.edit = true;
            element.loaded = true;
            element.priceHistories = {
              data: [],
              total: 1
            };
            element.total = Number(element.price) * Number(element.quantity);
          }
          this.productOrders = quota.quotaDetails;
          this.back = -1;
          this.order.quota = quota;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    }
    if (this.$route.query.copy_id) {
      this.$refs.bqouta.block();
      orderService
        .findOne(this.$route.query.copy_id)
        .then(res => {
          let order = res.data;
          order.id = '';
          order.code = '';

          self.order = Object.assign({}, order);
          self.order.dateReceipt = new Date(order.dateReceipt);
          self.order.dateDelivery = new Date(order.dateDelivery);
          order.orderDetails.forEach(element => {
            element.edit = true;
            element.loaded = true;
            element.priceHistories = {
              data: [],
              total: 1
            };
          });
          this.productOrders = order.orderDetails;
          this.back = -2;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    }
    if (this.$route.query.edit_id) {
      self.openEdit(this.$route.query.edit_id);
    }
  },
  methods: {
    updateCustomer() {
      if (this.order.customer && this.order.customer.customerContacts) {
        // if (this.order.customerContact == "") {
        //   this.order.customerContact = item;
        // }
      }
    },
    openEdit(id) {
      var self = this;
      this.$refs.bqouta.block();
      orderService
        .findOne(id)
        .then(res => {
          let order = res.data;
          order.orderDetails.forEach(element => {
            element.edit = true;
            element.loaded = true;
            element.priceHistories = {
              data: [],
              total: 1
            };
          });
          self.order = Object.assign({}, order);
          self.order.dateReceipt = new Date(order.dateReceipt);
          self.order.dateDelivery = new Date(order.dateDelivery);
          self.productOrders = order.orderDetails;
          self.back = -1;
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    },
    copyRow(row) {
      const tmp = Object.assign({}, row);
      tmp.id = null;
      this.productOrders.push(tmp);
      this.calcSummary();
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    productOrderAddRow() {
      this.productOrders.push({
        edit: true,
        product: {},
        productCustom: '',
        productSpecify: {},
        length: 0,
        color: '',
        colorCode2: '',
        colorCode: '',
        price: 0,
        currency: 'VND',
        total: 0,
        totalAmout: 0,
        quantity: 0,
        reason: {},
        reasonId: -1,
        tax: 0,
        onlyOnce: false,
        loaded: false,
        unit: 'met',
        priceHistories: {
          data: [],
          total: 0
        }
      });
    },
    productOrderDeleteRow(index, item) {
      if (item.edit) {
        this.productOrders.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    validateOrder() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        let validate = await self.$refs.csInfo.validate();
        self.productOrders.forEach(item => {
          if (!item.product || !item.product.id || !item.productSpecify || !item.productSpecify.id) {
            validate = false;
          }
        });
        if (validate) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async handleSave() {
      await this.validateOrder()
        .then(async () => {
          await this.doSave();
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    async handleSaveFromPreview(cb) {
      await this.validateOrder()
        .then(async () => {
          await this.doSave();
          cb();
        })
        .catch(() => {
          cb();
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    productChange(row) {
      row.productSpecify = '';
      row.price = 0;
      row.loaded = false;
    },
    viewHistory(item) {
      this.productOrderSelect = item;
      if (!item.productSpecify && !item.product) return;
      let customerId = this.order.customer ? this.order.customer.id : '';
      this.$refs.history.setData({
        productId: item.product.id,
        specId: item.productSpecify.id,
        color: item.color,
        customerId: customerId
      });
      this.$refs.history.visible = true;
    },
    productSpecifyChange(item) {
      if (item.productSpecify && item.productSpecify.color && item.productSpecify.color.id) {
        item.color = item.productSpecify.color;
      } else {
        item.color = '';
      }
      item.unit = item.productSpecify.unit;
      this.loadHistoryPrice(item);
    },
    quantityChange(item) {
      this.loadHistoryPrice(item);
      this.calcSummary();
    },
    priceChange() {
      this.calcSummary();
    },
    colorChange(item) {
      this.loadHistoryPrice(item);
    },
    loadHistoryPrice(item) {
      if (!item.productSpecify || !item.product || !item.color) return;
      let customerId = this.order.customer ? this.order.customer.id : '';
      let query = {
        limit: 10,
        page: 1,
        productId: item.product.id,
        specId: item.productSpecify.id,
        color: item.color.id,
        customerId: customerId
      };
      item.loaded = false;
      quotaService.history(query).then(res => {
        item.loaded = true;
        item.priceHistories = {
          data: res.data.data,
          total: res.data.total
        };
        let ListPrices = res.data.data;
        ListPrices.sort((a, b) => {
          if (Number(a.quantity) < Number(b.quantity)) {
            return 1;
          } else if (Number(a.quantity) > Number(b.quantity)) {
            return -1;
          }
          return 0;
        });
        let quantity = isNaN(Number(item.quantity)) ? Number(item.quantity.replace(/,/g, '')) : Number(item.quantity);
        item.quantity = quantity;
        for (let i = 0; i < ListPrices.length; i++) {
          const element = ListPrices[i];
          if (quantity >= element.quantity) {
            item.price = element.price;
            item.currency = element.currency;
            break;
          }
        }
        if (!item.price) {
          if (ListPrices.length > 0) {
            item.price = item.priceHistories.data[0].price;
            item.currency = item.priceHistories.data[0].currency;
          } else {
            item.price = 0;
          }
        }
      });
    },
    calcSummary() {
      this.summary.totalAmout = 0;
      this.summary.totalQuantity = 0;
      for (let i = 0; i < this.productOrders.length; i++) {
        const element = this.productOrders[i];
        this.summary.totalAmout += element.price * element.quantity;
        this.summary.totalQuantity += element.quantity;
        this.summary.currency = element.currency;
        this.summary.unit = element.unit;
      }
    },
    handelChoosePrice(price) {
      if (this.productOrderSelect) this.productOrderSelect.price = price;
    },
    doSave() {
      this.$refs.bqouta.block();
      let order = Object.assign({}, this.order);
      order.customer = {
        id: this.order.customer.id
      };

      order.customerContact = {
        id: this.order.customerContact.id
      };

      order.receiver = {
        id: this.order.receiver.id
      };

      order.receiverContact = {
        id: this.order.receiverContact.id
      };

      if (order.quota) {
        order.quotation = {
          id: order.quota.id
        };
      }
      delete order.quota;
      order.orderDetails = [];

      let productOrders = [];
      let summary = 0;
      this.productOrders.forEach(element => {
        let tmp = Object.assign({}, element);
        if (!this.$route.query.edit_id) {
          tmp.id = null;
        }

        tmp.product = {
          id: element.product.id
        };
        tmp.productSpecify = {
          id: element.productSpecify.id
        };
        tmp.total = Number(tmp.quantity) * Number(tmp.price);
        summary += tmp.total;
        delete tmp.priceHistories;
        productOrders.push(tmp);
      });
      order.amount = summary;

      orderService
        .create(order, productOrders)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.$router.push({
            name: 'add-order',
            query: {
              edit_id: res.data.id
            }
          });
          this.openEdit(res.data.id);
          // this.order.id = res.data.id;
          // this.order.userCreate = res.data.userCreate;
          // this.order.dateCreated = res.data.dateCreated;
          // this.order.code = res.data.code;

          // if (this.order.dateReceipt)
          //   this.order.dateReceipt = new Date(this.order.dateReceipt);
          // if (this.order.dateDelivery)
          //   this.order.dateDelivery = new Date(this.order.dateDelivery);
          // this.productOrders.forEach(element => {
          //   element.edit = false;
          // });
        })
        .finally(() => {
          this.$refs.bqouta.unBlock();
        });
    },
    doPrint() {
      this.validateOrder()
        .then(() => {
          this.$refs.preview.visible = true;
          this.$refs.preview.setData(this.order, this.productOrders);
        })
        .catch(error => {
          console.log(error);
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    doBack() {
      var self = this;
      this.$swal({
        title: 'Bạn có chắc thực hiện thao tác này?',
        text: 'Những thao tác bạn vừa thực hiện sẽ không được lưu lại',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Không',
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$router.go(self.back);
        }
      });
    },
    copyRecevier() {
      if (!this.order.customer || !this.order.customer.id) {
        this.$swal({
          title: 'Chưa nhập thông tin đặt hàng',
          showCancelButton: false,
          confirmButtonText: 'OK',
          reverseButtons: true
        });
        return;
      }
      this.order.receiver = Object.assign({}, this.order.customer);
      setTimeout(() => {
        this.order.receiverContact = Object.assign({}, this.order.customerContact);
      }, 1);
    },
    addNewCustomer(type = '') {
      this.$refs['customer-modal'].setStep(0);
      this.$refs['customer-modal'].visible = true;
      this.$refs['customer-modal'].setData({}, type);
    },
    addNewCustomerContact() {
      if (!this.order.customer || !this.order.customer.id) return;
      this.$refs['cs-contact-modal'].visible = true;
      this.$refs['cs-contact-modal'].setData(this.order.customer, {
        type: 'ORDER',
        isDefault: true
      });
    },
    addNewReceiverContact() {
      if (!this.order.receiver || !this.order.receiver.id) return;
      this.$refs['cs-contact-modal'].visible = true;
      this.$refs['cs-contact-modal'].setData(this.order.receiver, {
        type: 'SHIP',
        isDefault: true
      });
    },
    orderCustomerChange() {
      this.order.customerContact = '';
      if (this.order.customer && this.order.customer.customerContacts) {
        if (this.order.customer.customerContacts.length > 0) {
          for (let i = 0; i < this.order.customer.customerContacts.length; i++) {
            const element = this.order.customer.customerContacts[i];
            if (element.isDefault) {
              this.order.customerContact = element;
            }
          }
          if (!this.order.customerContact.id) this.order.customerContact = this.order.customer.customerContacts[0];
        }
      }
    },
    orderReceiverChange() {
      this.order.receiverContact = '';
      if (this.order.receiver && this.order.receiver.customerContacts) {
        if (this.order.receiver.customerContacts.length > 0) {
          for (let i = 0; i < this.order.receiver.customerContacts.length; i++) {
            const element = this.order.receiver.customerContacts[i];
            if (element.isDefault) {
              this.order.receiverContact = element;
            }
          }
          if (!this.order.receiverContact.id) this.order.receiverContact = this.order.receiver.customerContacts[0];
        }
      }
    },
    getReason(keyword, cb) {
      productService.findReason({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    reasonChange(modal, row) {
      row.reasonId = modal.id;
    }
  }
};
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 150px;
}
#add-order {
  .soft-control {
    .b-table-sticky-header {
      height: 500px;
      max-height: 500px;
    }
  }
}
</style>
